import React, { useEffect, useState } from 'react';
import { APP_VERSION } from '../../version';

interface VersionInfo {
  current: string;
  isLatest: boolean;
  serverVersion?: string;
}

const VersionDisplay: React.FC = () => {
  const [versionInfo, setVersionInfo] = useState<VersionInfo>({
    current: APP_VERSION,
    isLatest: true,
  });
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Check if we're running the latest version by checking the service worker cache
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        if (registrations.length > 0) {
          const registration = registrations[0];
          if (registration.waiting) {
            setVersionInfo((prev) => ({ ...prev, isLatest: false }));
          }
        }
      });
    }

    // Optional: Check server version via API
    checkServerVersion();
  }, []);

  const checkServerVersion = async () => {
    try {
      // You can implement an API endpoint that returns the deployed version
      // For now, we'll use a timestamp-based cache busting to check if index.html changed
      const response = await fetch('/version.json?' + Date.now(), {
        cache: 'no-cache',
      });
      if (response.ok) {
        const data = await response.json();
        if (data.version && data.version !== APP_VERSION) {
          setVersionInfo({
            current: APP_VERSION,
            isLatest: false,
            serverVersion: data.version,
          });
        }
      }
    } catch (error) {
      // Silently fail - version check is not critical
    }
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div style={{ position: 'relative' }}>
      <div
        onClick={() => setShowDetails(!showDetails)}
        style={{
          cursor: 'pointer',
          padding: '2px 0',
          fontSize: '12px',
          color: '#b5b5c3',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
        }}
      >
        <span>v{APP_VERSION}</span>
        {!versionInfo.isLatest && (
          <span
            style={{
              backgroundColor: '#f1416c',
              color: 'white',
              padding: '2px 6px',
              borderRadius: '4px',
              fontSize: '10px',
              fontWeight: 600,
            }}
          >
            UPDATE
          </span>
        )}
      </div>

      {showDetails && (
        <div
          style={{
            position: 'absolute',
            bottom: '100%',
            left: '0',
            marginBottom: '8px',
            backgroundColor: '#1e1e2d',
            border: '1px solid #3b3b4d',
            borderRadius: '6px',
            padding: '12px',
            minWidth: '200px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            zIndex: 1000,
          }}
        >
          <div style={{ marginBottom: '8px' }}>
            <div style={{ fontSize: '11px', color: '#7e8299', marginBottom: '4px' }}>
              Current Version
            </div>
            <div style={{ fontSize: '14px', fontWeight: 600 }}>v{versionInfo.current}</div>
          </div>

          {versionInfo.serverVersion && (
            <div style={{ marginBottom: '8px' }}>
              <div style={{ fontSize: '11px', color: '#7e8299', marginBottom: '4px' }}>
                Server Version
              </div>
              <div style={{ fontSize: '14px', fontWeight: 600, color: '#009ef7' }}>
                v{versionInfo.serverVersion}
              </div>
            </div>
          )}

          <div style={{ fontSize: '11px', color: '#7e8299', marginBottom: '8px' }}>
            Status:{' '}
            <span style={{ color: versionInfo.isLatest ? '#50cd89' : '#f1416c' }}>
              {versionInfo.isLatest ? 'Up to date' : 'Update available'}
            </span>
          </div>

          {!versionInfo.isLatest && (
            <button
              onClick={handleRefresh}
              style={{
                width: '100%',
                padding: '6px 12px',
                backgroundColor: '#009ef7',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: 500,
              }}
            >
              Refresh to Update
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default VersionDisplay;
